<template>
  <base-panel class="tw-flex-col" no-padding no-margin>
    <template v-if="showHeader" #header>
      <panel-header low-weight :text="$t('description')" />
    </template>

    <loading-content v-if="panelLoading" hide-title />
    <template v-else>
      <div ref="descriptionEl" :class="toggelClasses">
        <!-- danger -->
        <base-description
          v-if="mod?.description || mod?.summary"
          :content="mod.description || mod.summary"
        />
      </div>
      <div
        v-if="collapse && descriptionOverflow"
        class="tw-absolute tw-w-full tw-flex tw-justify-center tw-flex-col"
        :class="show ? 'tw--bottom-12' : 'tw--bottom-10'"
      >
        <div
          :class="show ? 'tw-opacity-0' : 'tw-opacity-100'"
          class="tw-transition-opacity tw-w-full tw-bg-gradient-to-t tw-from-[var(--tile-background-color)] tw-h-24"
        />
        <base-button
          v-if="collapse"
          class="tw-w-fit tw-mx-auto tw-z-2"
          :class="{ 'tw-top-8': show }"
          :icon="show ? 'angle-up' : 'angle-down'"
          auto-width
          primary
          @click="toggle"
        >
          {{ show ? $t('view_less') : $t('view_more') }}
        </base-button>
      </div>
    </template>
  </base-panel>
</template>

<script>
import LoadingContent from '@components/Loading/LoadingContent.vue'
import PanelHeader from '@components/PanelHeader.vue'
import { computed, toRefs, ref } from 'vue'
import { useToggle } from '@composables'

export default {
  components: {
    LoadingContent,
    PanelHeader,
  },
  props: {
    mod: {
      type: Object,
      default: null,
    },
    panelLoading: {
      type: Boolean,
      default: false,
    },
    showHeader: {
      type: Boolean,
      default: false,
    },
    collapse: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const { collapse } = toRefs(props)
    const { toggle, show } = useToggle(false)

    const windowWidth = ref(window.innerWidth)
    const descriptionEl = ref(null)

    const descriptionOverflow = computed(
      () =>
        windowWidth.value &&
        descriptionEl.value?.scrollHeight > descriptionEl.value?.clientHeight
    )

    const toggelClasses = computed(() => ({
      'tw-max-h-56 tw-overflow-hidden': collapse.value && !show.value,
      'tw-max-h-auto': collapse.value && show.value,
    }))

    return {
      descriptionOverflow,
      descriptionEl,
      toggelClasses,
      toggle,
      show,
    }
  },
}
</script>
